import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";
import Card from "@mui/material/Card";
// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import { Backdrop } from "@mui/material";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

import { CustomToastContent } from "../../examples/CustomToastContent/index";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  createIndustryMaster,
  deleteIndustryMaster,
  editIndustryMaster,
  getAllIndustryMaster,
  getSubModulesByRoleId,
  uploadCsvForIndustryMaster,
} from "../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = { ...style, p: 1, pt: 3 };

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const IndustryMaster = ({
  getAllIndustryReducer,
  getAllIndustryMaster,
  createIndustryMaster,
  editIndustryMaster,
  deleteIndustryMaster,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForIndustryMaster,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId || "system";
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "80f14403-a4be-4883-9534-b4c9ed6aaeb8",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "b1dedc9d-b5d5-4aea-b48e-041fc78d979d",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "8df11607-c82a-4755-84c0-05602b85d9bf",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "0b23bea3-dbdb-4d3a-b763-30b6a7c9129c",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "22e8ce2b-2151-4742-a4e5-66ef075f3aee",
    )
    : null;

  const [loading, setLoading] = useState(true);

  // Fetch Table Data
  useEffect(() => {
    getAllIndustryMaster(jwtToken);
  }, [jwtToken]);

  // DataTable State
  const [state, setState] = useState({
    columns: [
      { Header: "Industry ID", accessor: "industryId" },
      { Header: "Name", accessor: "name" },
      { Header: "Description", accessor: "description" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const headers = [
    { label: "Industry Name", key: "industryName" },
    { label: "Industry Description", key: "industryDescription" },
  ];

  const headersForTemp = [
    { label: "industryName", key: "industryName" },
    { label: "industryDescription", key: "industryDescription" },
  ];

  const csvExportData = (getAllIndustryReducer?.industryList?.data || []).map(
    (item) => ({
      industryName: item.name,
      industryDescription: item.description,
    }),
  );

  const csvLink = {
    filename: "Industry Master List.csv",
    headers: headers,
    data: csvExportData,
  };

  const csvLink2 = {
    filename: "Industry Master Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForIndustryMaster(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        setShowUploadPanel(false);
        setUploadCsvData(null);
        getAllIndustryMaster(jwtToken);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };

  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getAllIndustryReducer?.industryList?.data
      ? getAllIndustryReducer.industryList.data
      : [];

    setLoading(getAllIndustryReducer?.loading || false);

    // data.map((item) => {
    [...data].reverse().map((item) => {
      const itemObject = {
        industryId: item.industryId,
        name: item.name,
        description: item.description,

        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}

            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getAllIndustryReducer]);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isSuccessCreate, setIsSuccessCreate] = useState(false);
  const [isErrorCreate, setIsErrorCreate] = useState(false);
  const [errorMsgCreate, setErrorMsgCreate] = useState("");
  const [createButtonName, setCreateButtonName] = useState("Create");

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
    formik.setErrors({});
  };

  const handleCloseCreateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenCreateModal(false);
    formik.resetForm();
  };

  useEffect(() => {
    if (isSuccessCreate) setTimeout(() => setIsSuccessCreate(false), 3000);
    if (isErrorCreate) setTimeout(() => setIsErrorCreate(false), 3000);
  }, [isSuccessCreate, isErrorCreate]);

  const initialValues = {
    name: "",
    description: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(" "),
    description: Yup.string().required(" "),
  });

  const onSubmit = async (values, { resetForm }) => {
    setCreateButtonName("Please wait...");
    const payload = {
      name: values.name,
      description: values.description,
      cdBy: userId,
    };

    let res = await createIndustryMaster(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreate(true);
      getAllIndustryMaster(jwtToken);
      setTimeout(() => {
        setCreateButtonName("Create");
        handleCloseCreateModal();
      }, 2000);
    } else {
      setErrorMsgCreate(res?.data?.msg || "Something went wrong");
      setIsErrorCreate(true);
      setCreateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const initialValueForUpdate = {
    industryId: singleDataForUpdate.industryId || "",
    name: singleDataForUpdate.name || "",
    description: singleDataForUpdate.description || "",
  };

  const validationSchemaEdit = Yup.object({
    name: Yup.string().required(" "),
    description: Yup.string().required(" "),
  });

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      industryId: values.industryId,
      name: values.name,
      description: values.description,
      udBy: userId,
    };

    let res = await editIndustryMaster(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getAllIndustryMaster(jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    validationSchema: validationSchemaEdit,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  // ================= DELETE LOGIC =================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let id = singleDataForDelete.industryId;
    let udBy = userId;

    let res = await deleteIndustryMaster(id, udBy, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getAllIndustryMaster(jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (

    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={0}
                mb={-4.5}
                mt={-1}
              >
                <MDBox
                  color="text"
                  px={2}
                  ml={1}
                  mb={5}
                  mt={0.5}
                  display="flex"
                  alignItems="center"
                >
                  {allocateAccess && (
                    <MDBox display="flex" alignItems="center">
                      <Tooltip>
                        <CreateButton
                          tooltip="Add Industry Master"
                          color="info"
                          variant="contained"
                          type="button"
                          iconOnly
                          onClick={handleOpenCreateModal}
                          style={{ borderRadius: "5px" }}
                          size="small"
                        >
                          <Icon>add</Icon>
                        </CreateButton>
                      </Tooltip>
                      <CSVLink {...csvLink}>
                        <DownloadDataButton
                          tooltip="Download Industry Master List"
                          style={{ marginLeft: "1rem", marginTop: "2px" }}
                          type="button"
                          variant="outlined"
                          color="error"
                          iconOnly
                        >
                          <Icon>download</Icon>
                        </DownloadDataButton>
                      </CSVLink>

                      <UploadButton
                        tooltip="Upload CSV"
                        style={{ marginLeft: "1rem", marginTop: "4px" }}
                        type="button"
                        variant={showUploadPanel ? "contained" : "outlined"}
                        color="info"
                        iconOnly
                        onClick={handleUploadClick}
                      >
                        <Icon>upload</Icon>
                      </UploadButton>

                      <CSVLink {...csvLink2}>
                        <DownloadButton
                          tooltip="Download Template"
                          style={{ marginLeft: "1rem" }}
                          type="button"
                          variant="outlined"
                          color="error"
                          iconOnly
                        >
                          <Icon>description</Icon>
                        </DownloadButton>
                      </CSVLink>

                      {showUploadPanel && (
                        <MDBox
                          display="flex"
                          alignItems="center"
                          ml={2}
                          p={0.5}
                          px={2}
                        >
                          <input
                            className="choose_file"
                            type="file"
                            accept=".csv"
                            onChange={(e) => setUploadCsvData(e.target.files[0])}
                            style={{ width: "200px" }}
                          />

                          <MDButton
                            disabled={
                              !uploadCsvData?.name ||
                              uploadCsvData?.type !== "text/csv"
                            }
                            variant="contained"
                            color="info"
                            style={{ marginLeft: "1rem" }}
                            onClick={uploadCsvHandler}
                          >
                            UPLOAD
                          </MDButton>

                          <IconButton
                            size="small"
                            onClick={() => setShowUploadPanel(false)}
                            style={{ marginLeft: "10px", color: "gray" }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </MDBox>
                      )}
                    </MDBox>
                  )}
                </MDBox>
              </MDBox>

              {/* DataTable */}
              <MDBox pt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>

              {/* CREATE MODAL */}
              <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Industry Master
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseCreateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        {/* Name */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">Name</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="name"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.name && Boolean(formik.errors.name)
                              }
                            />
                            {formik.touched.name && formik.errors.name && (
                              <TextError msg={formik.errors.name} />
                            )}
                          </MDBox>
                        </Grid>

                        {/* Description */}
                        <Grid item xs={12} lg={6}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Description</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="description"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.description}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.description &&
                                Boolean(formik.errors.description)
                              }
                            />
                            {formik.touched.description &&
                              formik.errors.description && (
                                <TextError msg={formik.errors.description} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorCreate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgCreate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessCreate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Created Successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={createButtonName === "Please wait..."}
                            >
                              {createButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* UPDATE MODAL */}
              <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update Industry Master
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseUpdateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        {/* Readonly Industry ID */}
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1}>
                            <MDTypography variant="h6">Industry ID</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="industryId"
                              fullWidth
                              disabled={true}
                              value={formikForUpdate.values.industryId}
                            />
                          </MDBox>
                        </Grid>

                        {/* Name */}
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Name</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="name"
                              fullWidth
                              autoComplete="off"
                              value={formikForUpdate.values.name}
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.name &&
                                Boolean(formikForUpdate.errors.name)
                              }
                            />
                            {formikForUpdate.touched.name &&
                              formikForUpdate.errors.name && (
                                <TextError msg={formikForUpdate.errors.name} />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Description */}
                        <Grid item xs={12} lg={4}>
                          <MDBox mb={1} ml={1}>
                            <MDTypography variant="h6">Description</MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="description"
                              fullWidth
                              autoComplete="off"
                              value={formikForUpdate.values.description}
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.description &&
                                Boolean(formikForUpdate.errors.description)
                              }
                            />
                            {formikForUpdate.touched.description &&
                              formikForUpdate.errors.description && (
                                <TextError
                                  msg={formikForUpdate.errors.description}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={editButtonName === "Please wait..."}
                            >
                              {editButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* DELETE MODAL */}
              <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
                <MDCard sx={deleteStyle}>
                  <MDTypography>Are you sure you want to delete?</MDTypography>
                  <MDBox mt={2} display="flex" justifyContent="space-between">
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      color="error"
                      onClick={deleteRecord}
                      disabled={deleteButtonName === "Please wait..."}
                    >
                      {deleteButtonName}
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorForDelete}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsErrorForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForDelete}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsSuccessForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

            </Card>

          </Grid>


        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />

      <Footer />

    </DashboardLayout>
  );
};

// Redux mapping
const mapStateToProps = (state) => ({
  getAllIndustryReducer: state.getAllIndustryReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getAllIndustryMaster: (jwtToken) => dispatch(getAllIndustryMaster(jwtToken)),
  createIndustryMaster: (payload, jwtToken) =>
    dispatch(createIndustryMaster(payload, jwtToken)),
  editIndustryMaster: (payload, jwtToken) =>
    dispatch(editIndustryMaster(payload, jwtToken)),
  deleteIndustryMaster: (id, udBy, jwtToken) =>
    dispatch(deleteIndustryMaster(id, udBy, jwtToken)),
  uploadCsvForIndustryMaster: (payload, jwtToken) =>
    dispatch(uploadCsvForIndustryMaster(payload, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IndustryMaster);
